import { type MouseEventHandler } from 'react'
import * as S from './NewProductsGrid.styles'
import { MULTI_PRODUCT_NAV_STATE } from '../../multiProductHomePage.consts'

export type NewProductItem = {
  label: string
  alt: string
  imageUrl: string
  to: string
  external?: boolean
  onClick: MouseEventHandler<HTMLElement>
}

type Props = {
  title: string
  items: NewProductItem[]
}

export default function NewProductsGrid({ title, items }: Props) {
  return (
    <S.Section data-testid="multi-product-new-products">
      <S.Title>{title}</S.Title>
      <S.Grid>
        {items.map((item) => (
          <S.Card
            key={item.alt}
            to={item.to}
            state={item.external ? undefined : MULTI_PRODUCT_NAV_STATE}
            reloadDocument={item.external}
            onClick={item.onClick}
            data-testid={`new-product-${item.alt
              .toLowerCase()
              .replace(/\s+/g, '-')}`}
          >
            <S.CardImage src={item.imageUrl} alt={item.alt} />
            <S.CardScrim />
            <S.CardLabel>{item.label}</S.CardLabel>
          </S.Card>
        ))}
      </S.Grid>
    </S.Section>
  )
}
